<template>
  <div class="activity-box" id="activity">
    <div>
      <div class="activity-top">
        <h1>{{ $t("activity.title") }}</h1>
        <p>{{ $t("activity.describe") }}</p>
      </div>
      <div class="activity-view">
        <div class="activity-item" v-for="(item, index) in activityList" :key="index">
          <img :src="'./static/image/' + item.img" alt="" />
          <div>
            <p>{{ item.title }}</p>
            <p>{{ item.describe }}</p>
            <p>
              <span>{{ item.time }}</span><span class="more" @click="onDetails(item, index)">{{ $t("activity.buttonText")
              }}
                &gt;</span>
            </p>
          </div>
        </div>
      </div>
      <div class="activity-more">
        <el-button round @click="onActivityList">
          {{ $t("activity.more") }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => {
    return {
      activityList: [],
      keepScroll:0
      // list: require('@/static/data.js'),
    };
  },
  computed: {
    list() {
      return []
    },
  },
  created() {
    this.intData()
  },
  methods: {
    intData() {
      //引用axios
      const lang = localStorage.getItem("lang");
      switch (lang) {
        case 'en':
          axios.get("/static/lang/en.json", {})
            .then(({ data }) => {

              this.activityList = data.ActivityList.reverse();
              if (this.activityList.length >= 6) {
                this.activityList.length = 6;

              }
            })
          break;
        case 'Czh':
          //获取数据（访问路径不用带public ，直接访问public下的文件即可）
          axios.get("/static/lang/Czh.json", {})
            .then(({ data }) => {
              this.activityList = data.ActivityList.reverse();
              if (this.activityList.length >= 6) {
                this.activityList.length = 6;

              }
            })

          break;

        default:
          //获取数据（访问路径不用带public ，直接访问public下的文件即可）
          axios.get("/static/lang/zh.json", {})
            .then(({ data }) => {

              this.activityList = data.ActivityList.reverse();
              if (this.activityList.length >= 6) {
                this.activityList.length = 6;

              }
            })

          break;
      }

    },
    onActivityList() {
      this.$router.push("/activity");
    },
    onDetails(item, index) {
       const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
        this.keepScroll = scrollTop;
      localStorage.setItem("details", JSON.stringify(item))
      this.$router.push({ path: "/activity/details", query: { index } });
    },
  },
};
</script>
<style lang="less" scoped>
.activity-box {
  width: 100%;
  background-color: #fff;
  padding: 60px 0;

  >div {
    width: 1280px;
    margin: auto;
  }

  .activity-top {
    h1 {
      font-size: 40px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 56px;
      margin-bottom: 10px;
    }

    p {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
      margin-bottom: 60px;
    }
  }

  .activity-view {
    display: flex;
    flex-wrap: wrap;

    .activity-item {
      display: flex;
      flex-direction: column;
      border-radius: 8px;
      width: 408px;
      height: 486px;
      border-radius: 8px;
      border: 1px solid #dddddd;
      margin-bottom: 24px;

      img {
        width: 408px;
        height: 310px;
        background: #d8d8d8;
        border-radius: 8px 8px 0px 0px;
      }

      div {
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 176px;
      }

      P:nth-of-type(1) {
        display: -webkit-box;
        /* Safari */
        -webkit-line-clamp: 2;
        /* Safari and Chrome */
        -webkit-box-orient: vertical;
        overflow: hidden;
        /* Safari and Chrome */

        overflow: hidden;
        font-size: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #000000;
      }

      p:nth-of-type(2) {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #616364;
        white-space: nowrap;
        /* 防止换行 */
        overflow: hidden;
        /* 控制元素大小并隐藏溢出部分 */
        text-overflow: ellipsis;
      }

      p:nth-of-type(3) {
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
          font-size: 14px;
          color: #dddddd;
        }

        .more {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #0041f0;
          cursor: pointer;
        }

        .more:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

    .activity-item:not(:nth-of-type(3n + 3)) {
      margin-right: 25px;
    }
  }

  .activity-more {
    margin: 60px auto;
    font-size: 16px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    color: #0041f0;
    text-align: center;
    line-height: 54px;
    cursor: pointer;
    margin-bottom: 0;
    margin-top: 40px;

    .el-button {
      width: 140px;
      height: 54px;
      border-radius: 27px;
      border-color: #0041f0;
      color: #0041f0;
    }
  }
}

@media screen and (max-width: 1080px) {
  .activity-box {
    width: 100%;
    background-color: #fff;
    padding-top: 8rem;
    padding-bottom: 8rem;

    >div {
      width: 108rem;
      margin: auto;
      padding: 5rem;
      box-sizing: border-box;
    }

    .activity-top {
      h1 {
        font-size: 5.3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 7.3rem;
        margin-bottom: 2rem;
      }

      p {
        font-size: 3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 4.3rem;
      }
    }

    .activity-view {
      display: flex;
      flex-wrap: wrap;

      .activity-item {
        display: flex;
        flex-direction: column;

        width: 97rem;
        height: 100rem;
        border-radius: 1.6rem;
        border: 0.2rem solid #dddddd;
        margin-bottom: 24px;

        img {
          width: 97rem;
          height: 65.6rem;
          background: #d8d8d8;
          border-radius: 2rem 2rem 0px 0px;
        }

        div {
          padding: 5rem;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 35.6rem;
        }

        P:nth-of-type(1) {
          display: -webkit-box;
          /* Safari */
          -webkit-line-clamp: 2;
          /* Safari and Chrome */
          -webkit-box-orient: vertical;
          /* Safari and Chrome */

          overflow: hidden;
          font-size: 4.5rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #000000;
        }

        p:nth-of-type(2) {
          font-size: 3.5rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #616364;
          white-space: nowrap;
          /* 防止换行 */
          overflow: hidden;
          /* 控制元素大小并隐藏溢出部分 */
          text-overflow: ellipsis;
        }

        p:nth-of-type(3) {
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            font-size: 3.5rem;
            color: #dddddd;
          }

          .more {
            font-size: 3.5rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #0041f0;
            cursor: pointer;
          }

          .more:hover {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }

      // .activity-item:not(:nth-of-type(3n+3)) {
      //     margin-right: 25px;
      // }
    }

    .activity-more {
      margin: 8rem auto;
      font-size: 4rem;
      font-family: MiSans, MiSans;
      font-weight: 400;
      color: #0041f0;
      text-align: center;
      cursor: pointer;

      .el-button {
        width: 98rem;
        height: 13.6rem;
        border-radius: 6.8rem;
        border: 0.3rem solid #0041f0;
        border-color: #0041f0;
        color: #0041f0;
        font-size: 4rem;
      }
    }
  }
}
</style>